import {Component, inject, Input} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ModalComponent} from "../modal.component";
import {ModalService} from "src/app/shared/data-access/modal.service";
import {SolutionService} from "src/app/features/knowledge-database/data-access/solution.service";

@Component({
  selector: "app-media-modal",
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: "./media-modal.component.html",
  styles: [
    `
      .image-wrapper,
      .video-wrapper,
      .pdf-wrapper {
        width: 100%;
        height: 95%;
      }

      img,
      video,
      iframe {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    `,
  ],
})
export class MediaModalComponent {
  modalService = inject(ModalService);
  solutionService = inject(SolutionService);

  get isImage(): boolean {
    return this.solutionService.selectedMediaFile().type.includes("image/");
  }

  get isVideo(): boolean {
    return this.solutionService.selectedMediaFile().type.includes("video/");
  }

  get isPdf(): boolean {
    return this.solutionService
      .selectedMediaFile()
      .type.includes("application/pdf");
  }

  get isSupported(): boolean {
    return this.isImage || this.isVideo || this.isPdf;
  }

  openModal() {
    this.modalService.openModal("mediaSolutionModal");
  }

  closeModal() {
    this.modalService.closeModal("mediaSolutionModal");
  }
}
